import { Filter, Plus } from 'lucide-react';
import { Input, Select } from '@/components/ui';
import { AuthButton } from '@/core/permissions/AuthButton';
import type { WarehouseFilters } from '../types/warehouses.types';

interface WarehousesToolbarProps {
  filters: WarehouseFilters;
  onSearchChange: (val: string) => void;
  onStatusChange: (val: string) => void;
  onAdd: () => void;
}

export function WarehousesToolbar({ filters, onSearchChange, onStatusChange, onAdd }: WarehousesToolbarProps) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-slate-800">Danh sách kho bãi</h3>
        <AuthButton
          module="inventory.warehouses"
          action="create"
          behavior="disable"
          className="bg-emerald-600 hover:bg-emerald-700 text-white h-9 px-4 rounded-md inline-flex items-center gap-2 sm:text-sm text-xs"
          onClick={onAdd}
        >
          <Plus className="w-4 h-4" />
          <span className="hidden sm:inline">Thêm kho bãi</span>
        </AuthButton>
      </div>

      <div className="flex items-center gap-3 bg-white p-3 border border-slate-200 rounded-md">
        <div className="relative flex-1 max-w-sm">
          <Filter className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <Input
            value={filters.search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Tìm theo tên, mã kho..."
            className="pl-9 h-9 sm:text-sm text-xs"
          />
        </div>
        <div className="w-48">
          <Select
            value={String(filters.is_active)}
            onChange={(e) => onStatusChange(e.target.value)}
            className="h-9 sm:text-sm text-xs"
          >
            <option value="all">Tất cả trạng thái</option>
            <option value="true">Đang hoạt động</option>
            <option value="false">Ngừng hoạt động</option>
          </Select>
        </div>
      </div>
    </div>
  );
}
